import api from '@/modules/axios'

export default {
    supportArticles(params) {
        const domain = window.location.hostname
        if (domain === 'reg.ru' || domain === 'www.reg.ru') {
            return api({
                url: `/hc/ru/autocomplete?word=${params.word}`,
                baseURL: 'https://help.reg.ru/'
            })
        } else {
            return api({
                url: `/regru/regru/test-support?word=${params.word}`
            })
        }
    }
}
